import { ALERT_TYPES, type AlertType } from './alert.enum';

export const ALERT_ICON_MAP: Partial<Record<AlertType, string>> = {
    [ALERT_TYPES.INFO]: 'badge-info',
    [ALERT_TYPES.SUCCESS]: 'circle-check',
    [ALERT_TYPES.WARNING]: 'octagon-alert',
    [ALERT_TYPES.ERROR]: 'triangle-alert',
};

export const ALERT_DEFAULT_ANIMATION_DURATION = 500;
